import axios from 'axios';
import {
  PARTNER_LVC_ENROLLMENTS_API,
  PARTNER_USER_LVC_OFFERINGS_API,
} from 'config/constants';
import type {
  PartnerLvcEnrollment,
  PartnerLvcOffering,
} from 'types/partnerEnrollment';

interface ItemsResponse<T> {
  items: T[];
}

export async function getPartnerLvcEnrollments(): Promise<
  PartnerLvcEnrollment[]
> {
  try {
    const { data } = await axios.get<ItemsResponse<PartnerLvcEnrollment>>(
      PARTNER_LVC_ENROLLMENTS_API,
    );
    return Array.isArray(data?.items) ? data.items : [];
  } catch (error) {
    throw error;
  }
}

export async function getPartnerUserLvcOfferings(): Promise<
  PartnerLvcOffering[]
> {
  try {
    const { data } = await axios.get<ItemsResponse<PartnerLvcOffering>>(
      PARTNER_USER_LVC_OFFERINGS_API,
    );
    return Array.isArray(data?.items) ? data.items : [];
  } catch (error) {
    throw error;
  }
}
